// TODO (Sergio): Remove lint skip instruction
/* eslint-disable complexity */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatAmount'
})
export class FormattedAmountPipe implements PipeTransform {
  transform(
    value: string,
    notToSplitDecimal?: boolean,
    currencyCode?: string,
    currencySymbol?: string
  ): string {
    if (value) {
      value = value.replace('undefined', '');
      const splitedArray: Array<string> = notToSplitDecimal
        ? [value]
        : value.split('.');
      let numericPart: string;
      let fractionalPart: string;
      let formattedAmount = '';
      numericPart = splitedArray[0];
      fractionalPart = splitedArray[1]
        ? `<span class="curr-sign">.${splitedArray[1]}</span>`
        : '';
      if (splitedArray.length === 1 && currencyCode) {
        const amount: Array<string> = numericPart.split(currencyCode);
        if (numericPart.indexOf(currencyCode) !== -1) {
          fractionalPart = `<span class="curr-sign">${currencyCode}</span>`;
        }
        numericPart = amount.filter((amount) => amount != '')[0];
      }
      if (currencySymbol) {
        const amount: Array<string> = numericPart.split(currencySymbol);
        if (amount.length > 1) {
          formattedAmount = `<span class="curr-sign">${currencySymbol.trim()}</span>`;
          numericPart = amount[1];
        } else {
          numericPart = amount.filter((amount) => amount != '')[0];
        }
      }
      formattedAmount += numericPart.trim();
      formattedAmount += fractionalPart;
      return formattedAmount;
    }
    return '';
  }
}
